import { AdminAppState, PlaceEntry } from '../../state';
import { getPlace } from './get-place';

export const getPlacePageId = (placeKey: string) => (
  store: AdminAppState,
): PlaceEntry['place']['pageId'] => getPlace(placeKey)(store).pageId;
